import { render } from "./DailyReportEventDeleteModal.vue?vue&type=template&id=5fe00f86"
import script from "./DailyReportEventDeleteModal.vue?vue&type=script&lang=ts"
export * from "./DailyReportEventDeleteModal.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QCardActions,QBtn});
